import React, { useEffect, useState } from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { AiOutlineHome } from "react-icons/ai";
import { FaArrowLeft } from "react-icons/fa";
import { useHistory } from "react-router-dom";
import dataStorage from '../../dataStorage/dataStorage';
import { ClientSettingsModel } from '../../models/DataModels';
import MpaasAdminPanelApi from '../../utils/MpaasAdminPanelApi';
import ToggleSwitch from '../toggleSwitch/ToggleSwitch';
import './globalSettings.css';
import {ReactComponent as Info} from "../../images/info.svg"

const MiscellaneousSettings: React.FC = () => {
    const history = useHistory();

    const [clientSettings, setClientSettings] = useState <ClientSettingsModel>({
        allowClientTheme: false,
        allowBranding: false,
        allowSupportContact: false,
        enableVideoPlayback: false,
        enableChatAttachmentSupport: false
    })

    const saveClientSettings = () => {
        const payload = {
            ALLOW_CLIENT_THEME: clientSettings.allowClientTheme,
            SHOW_BRANDING_IN_FOOTER: clientSettings.allowBranding,
            SHOW_SUPPORT_CONTACT_IN_FOOTER: clientSettings.allowSupportContact,
            ENABLE_VIDEO_PLAYBACK: clientSettings.enableVideoPlayback,
            ENABLE_CHAT_ATTACHMENT_SUPPORT: clientSettings.enableChatAttachmentSupport
        }

        const clientId = dataStorage.getClientSettings()[0]?.mpaasClientId;

        MpaasAdminPanelApi.saveClientSettings({ clientId, payload }).then((data: any) => {
            console.log('Saved client settings.');
            alert('Saved client settings');
        }).catch((err) => {
            console.log('Failed to save client settings', err);
            alert('Failed to save client settings');
        })
    }

    const fetchClientSettings = () => {
        const clientId = dataStorage.getClientSettings()[0]?.mpaasClientId;

        if(!clientId){
            history.push('/settings/accountDetails')
            return;
        }

        MpaasAdminPanelApi.fetchClientSettings({ clientId }).then((data: any) => {

            setClientSettings({
                allowClientTheme: data?.clientSettings?.ALLOW_CLIENT_THEME,
                allowBranding: data?.clientSettings?.SHOW_BRANDING_IN_FOOTER,
                allowSupportContact: data?.clientSettings?.SHOW_SUPPORT_CONTACT_IN_FOOTER,
                enableVideoPlayback: data?.clientSettings?.ENABLE_VIDEO_PLAYBACK,
                enableChatAttachmentSupport: data?.clientSettings?.ENABLE_CHAT_ATTACHMENT_SUPPORT
            })

        }).catch((err) => {
            history.push('/settings/accountDetails')
            alert('Failed to Fetch client settings');
        })
    }

    const toggleClientSettings = (updatedSetting: any) => {
        setClientSettings((data: ClientSettingsModel) => {
            return {...data, ...updatedSetting}
        })
    }

    useEffect(() => {
        fetchClientSettings();
    }, [])

    return (
        <div>
            <div className='breadcrumb-section'>
                <AiOutlineHome /> <span className="small"> &gt; <span className="text-muted">Settings</span> &gt; <span className="text-muted">Account Details</span> &gt; <span className="text-muted">Miscellaneous Settings</span></span>
                <div className='d-flex mt-3 ml-2'>
                    <FaArrowLeft className='mr-3 mt-1 cursor-pointer' onClick={() => history.push('/settings/accountDetails')} />
                    <span className=''>
                        <span className='font-weight-bold h5 text-quill-lighter'>Miscellaneous Settings</span>
                        <div className='font-weight-light text-quill-lighter mt-1'>You can configure other available settings for Windows & Mac</div>
                    </span>
                </div>

                <div className='setting-container mt-5 mx-3 pr-5'>
                    <div className='w-100 client-theme d-flex justify-content-between'>
                        <div>
                            <div className='font-weight-bold h6 text-quill-lighter'>Allow Client Theme</div>
                            <div className='font-weight-light'>When enabled, Client can configure SecureProctor theme.</div>
                        </div>
                        <div>
                            <ToggleSwitch isEnabled={clientSettings.allowClientTheme} onToggle={() => toggleClientSettings({allowClientTheme: !clientSettings.allowClientTheme})} />
                        </div>
                    </div>
                    <div className='mt-4 d-flex justify-content-center align-items-center w-100'><div className='branding'>Configure Marsh Branding</div> <hr className='w-100'></hr></div>
                    <div className='mt-4 w-100 client-theme d-flex justify-content-between'>
                        <div>
                            <div className='font-weight-bold h6 text-quill-lighter'>Show <img className='brand-logo' src='./marsh-logo-midnight.svg' alt="Marsh logo"/> branding in SecureProctor's Footer</div>
                            <div className='font-weight-light'>When enabled, Marsh branding will be visible in SecureProctor's footer</div>
                        </div>
                        <div>
                            <ToggleSwitch isEnabled={clientSettings.allowBranding} onToggle={() => toggleClientSettings({allowBranding: !clientSettings.allowBranding})} />
                        </div>
                    </div>
                    <div className='mt-4 w-100 client-theme d-flex justify-content-between'>
                        <div>
                            <div className='font-weight-bold h6 text-quill-lighter'>Show support contact information in SecureProctor's Footer</div>
                            <div className='font-weight-light'>When enabled, Marsh support information will be visible in SecureProctor's footer</div>
                        </div>
                        <div>
                            <ToggleSwitch isEnabled={clientSettings.allowSupportContact} onToggle={() => toggleClientSettings({allowSupportContact: !clientSettings.allowSupportContact})} />
                        </div>
                    </div>

                    <div className='w-100 client-theme d-flex justify-content-between mt-4'>
                        <div>
                            <span className='font-weight-bold h6 text-quill-lighter'>Allow access to previously recorded videos</span>
                             <OverlayTrigger placement="top" overlay={
                                <Tooltip id="tooltip">
                                    Make sure full session recording is enabled from Proctoring settings
                                </Tooltip>}>
                                <Info className="tooltip-margin" />
                            </OverlayTrigger>
                        </div>
                        <div>
                            <ToggleSwitch isEnabled={clientSettings.enableVideoPlayback} onToggle={() => toggleClientSettings({enableVideoPlayback: !clientSettings.enableVideoPlayback})} />
                        </div>
                    </div>

                    <div className='w-100 client-theme d-flex justify-content-between mt-4'>
                        <div>
                            <div className='font-weight-bold h6 text-quill-lighter'>Enable proctor image to candidate
                            </div>
                             <div className='font-weight-light'>This flow is not applicable for LMS clients</div>
                        </div>
                        <div>
                            <ToggleSwitch isEnabled={clientSettings.enableChatAttachmentSupport} onToggle={() => toggleClientSettings({enableChatAttachmentSupport: !clientSettings.enableChatAttachmentSupport})} />
                        </div>
                    </div>

                </div>
                <div className='w-100 mt-5'>
                    <Button variant='primary' className='ml-3 p-2' onClick={saveClientSettings}>Save Changes</Button>
                </div>
            </div>
        </div>
    )
}

export default MiscellaneousSettings;